import { useEffect, useState } from 'react';
import { accountCalendarsQuery, subscribe } from '@/lib/firestore';
import type { Calendar } from '@/schemas';

export type CalendarWithId = Calendar & { id: string };

export function useCalendars(aid: string | null): {
  calendars: CalendarWithId[];
  loading: boolean;
} {
  // Derived loading: see useMyMemberships for the why.
  const [state, setState] = useState<{ loadedAid: string | null; data: CalendarWithId[] }>({
    loadedAid: null,
    data: [],
  });
  useEffect(() => {
    if (!aid) {
      setState({ loadedAid: null, data: [] });
      return;
    }
    setState({ loadedAid: null, data: [] });
    const unsub = subscribe<Calendar>(accountCalendarsQuery(aid), (rows) => {
      setState({ loadedAid: aid, data: rows });
    });
    return unsub;
  }, [aid]);
  return {
    calendars: state.loadedAid === aid ? state.data : [],
    loading: aid != null && state.loadedAid !== aid,
  };
}
